/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ResponseApi,
  ResponseApiListRoleDTO,
  ResponseApiRoleDTO,
  RoleDO,
  RoleMenuEditDO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class XiTongJiaoSeGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name QueryUsingGet4
   * @summary 查询角色
   * @request GET:/dsp-admin/api/sys/roles
   * @secure
   */
  queryUsingGet4 = (
    query: {
      /**
       * 页码 (1..N)
       * @format int64
       */
      pageNum: number;
      /**
       * 每页显示的数目
       * @format int64
       */
      pageSize: number;
      role?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name CreateUsingPost2
   * @summary 新增角色
   * @request POST:/dsp-admin/api/sys/roles
   * @secure
   */
  createUsingPost2 = (resources: RoleDO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles`,
      method: "POST",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name UpdateUsingPut2
   * @summary 修改角色
   * @request PUT:/dsp-admin/api/sys/roles
   * @secure
   */
  updateUsingPut2 = (resources: RoleDO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles`,
      method: "PUT",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name DeleteUsingDelete2
   * @summary 删除角色
   * @request DELETE:/dsp-admin/api/sys/roles
   * @secure
   */
  deleteUsingDelete2 = (ids: number[], params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles`,
      method: "DELETE",
      body: ids,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name QueryUsingGet6
   * @summary 返回全部的角色
   * @request GET:/dsp-admin/api/sys/roles/all
   * @secure
   */
  queryUsingGet6 = (params: RequestParams = {}) =>
    this.request<ResponseApiListRoleDTO, void>({
      path: `/dsp-admin/api/sys/roles/all`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name GetLevelUsingGet
   * @summary 获取用户级别
   * @request GET:/dsp-admin/api/sys/roles/level
   * @secure
   */
  getLevelUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles/level`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name UpdateMenuUsingPut1
   * @summary 修改角色菜单
   * @request PUT:/dsp-admin/api/sys/roles/menu
   * @secure
   */
  updateMenuUsingPut1 = (
    resources: RoleMenuEditDO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles/menu`,
      method: "PUT",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name OptionsUsingGet
   * @summary 角色下拉选项
   * @request GET:/dsp-admin/api/sys/roles/option
   * @secure
   */
  optionsUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/roles/option`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongJiaoSeGuanLi
   * @name QueryUsingGet5
   * @summary 获取单个role
   * @request GET:/dsp-admin/api/sys/roles/{id}
   * @secure
   */
  queryUsingGet5 = (id: number, params: RequestParams = {}) =>
    this.request<ResponseApiRoleDTO, void>({
      path: `/dsp-admin/api/sys/roles/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new XiTongJiaoSeGuanLi();
